import type { Config } from "./config";
import type { Result } from "./result";

export type InitFunction<TConfig extends Config = Config> = (
	cfg: TConfig
) => Promise<void> | void;

export type GetItemsFunction<TItem, TConfig extends Config = Config> = (
	cfg: TConfig
) =>
	| TItem[]
	| Promise<TItem[]>
	| AsyncGenerator<TItem, void, void>
	| Generator<Promise<TItem> | TItem, void, void>;

export type GetItemIdFunction<TItem, TConfig extends Config = Config> = (
	item: TItem,
	cfg: TConfig
) => string;

export type ProcessFunction<TItem, TConfig extends Config = Config> = (
	item: TItem,
	cfg: TConfig,
	attempt: number
) => Promise<Result | string | void> | Result | string | void;

export type FinalizeFunction<TConfig extends Config> = (
	cfg: TConfig,
	dsp: Disposition
) => Promise<void> | void;

export enum Disposition {
	NotComplete = "Not Complete",
	Successful = "Successful",
	Failed = "Failed",
	Cancelled = "Cancelled"
}

export enum JobFunction {
	Init = "init",
	GetItems = "getItems",
	GetItemId = "getItemId",
	Process = "process",
	Finalize = "finalize"
}

export interface Job<TConfig extends Config, TItem> {
	defaultConfig?: Config;
	init?: InitFunction<TConfig>;
	getItems: GetItemsFunction<TItem, TConfig>;
	getItemId?: GetItemIdFunction<TItem, TConfig>;
	process: ProcessFunction<TItem, TConfig>;
	finalize?: FinalizeFunction<TConfig>;
}
